import styled from 'styled-components'

import { media } from 'src/styles/media'

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1rem;
  width: 100%;
  flex-grow: 1;

  ${media.desktop} {
    padding-top: 12.8rem;
  }
`
